module.exports = __webpack_public_path__ + "assets/img/wifi.aee7a1cced6b103eac224be8d3363f44.svg";